import { ERegionCode } from 'sure-platform-sdk';

import { TCopyConfig } from '../interfaces';
import copyConfigMerge from '../services/copyConfigMerge';
import { isServer } from '../services/env';
import mergeConfig from '../services/mergeConfig';

const defaultCopyConfig = require('./copy/toggle');

function retrieveConfig(filename: string) {
  try {
    // eslint-disable-next-line import/no-dynamic-require, global-require
    return require(`./copy/${filename}`).default;
  } catch (e) {
    return {};
  }
}

const tenant = process.env.REACT_APP_TENANT || 'toggle';
function getEnvConfig(filename = tenant) {
  if (isServer || !tenant) {
    return {};
  }

  const { copyConfigTestHelper, Cypress } = window;

  const config = retrieveConfig(filename);

  return (
    (Cypress && copyConfigTestHelper && copyConfigTestHelper(config)) ||
    config ||
    {}
  );
}

function getRegionConfig(regionCode?: ERegionCode, tenantOverride = '') {
  return getEnvConfig(`${tenantOverride || tenant}/${regionCode || 'index'}`);
}

const mergedConfig: TCopyConfig = mergeConfig<TCopyConfig>(
  defaultCopyConfig.default,
  getEnvConfig()
);

export function regionConfig(regionCode?: ERegionCode): TCopyConfig {
  const mergedRegionConfig = mergeConfig<TCopyConfig>(
    getRegionConfig(regionCode, 'toggle'),
    getRegionConfig(regionCode)
  );
  return copyConfigMerge(mergedConfig, mergedRegionConfig);
}

export default mergedConfig;
